import { render } from "./ProductCost.vue?vue&type=template&id=31ba2d93&scoped=true"
import script from "./ProductCost.vue?vue&type=script&lang=js"
export * from "./ProductCost.vue?vue&type=script&lang=js"

import "./ProductCost.vue?vue&type=style&index=0&id=31ba2d93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ba2d93"]])

export default __exports__